import { useEffect, useState } from 'react';
import constate from 'constate';
import { graphql, useStaticQuery } from 'gatsby';

const useApp = () => {
  const [basket, setBasket] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [basketEmptied, setBasketEmptied] = useState(false);
  const [basketValue, setBasketValue] = useState(0);
  const [basketWeight, setBasketWeight] = useState(0);
  const [orderStatus, setOrderStatus] = useState('not started');

  const products = useStaticQuery(graphql`
    query {
      allGoogleProductsSheet {
        edges {
          node {
            slug
            title
            price
            images
            category
            sku
            weight
          }
        }
      }
    }
  `);

  const spreadsheetId = '1oex5iPuL8ZOThhno7gBRPfHCM0rgeR3v31dWEqrR0qg';
  const apiUrl =
    process.env.NODE_ENV === 'development'
      ? '/api/google-sheets/data'
      : '/.netlify/functions/google-sheets';
  const sheet = 'products';
  async function fetchData() {
    try {
      const response = await fetch(
        `${apiUrl}?id=${spreadsheetId}&sheet=${sheet}`
      );
      if (!response.ok) {
        console.error('fetchData: non-OK response', response.status);
        setProductsData([]);
        return;
      }
      const result = await response.json();
      // Log the raw result to help debugging
      // eslint-disable-next-line no-console
      console.log('google-sheets fetch result:', result);

      // Normalize common shapes: array, { data: [...] }, { rows: [...] }
      let array = null;
      if (Array.isArray(result)) array = result;
      else if (result && Array.isArray(result.data)) array = result.data;
      else if (result && Array.isArray(result.rows)) array = result.rows;

      if (Array.isArray(array)) {
        const normalized = array.map((item) => {
          const statusRaw = item.status || item.Status || '';
          const categoryRaw = item.category || item.Category || '';
          const category2Raw = item.category2 || item.Category2 || '';
          const images = item.images || item.Images || '';
          const price = item.price || item.Price || 0;
          const title = item.title || item.Title || item.name || '';
          const slug = item.slug || item.Slug ||
            (title && title.toLowerCase().replace(/[^a-z0-9]+/gi, '-')) || '';
          return {
            ...item,
            status: (typeof statusRaw === 'string' && statusRaw.toLowerCase) ? statusRaw.toLowerCase() : statusRaw,
            category: (typeof categoryRaw === 'string' && categoryRaw.toLowerCase) ? categoryRaw.toLowerCase() : categoryRaw,
            category2: (typeof category2Raw === 'string' && category2Raw.toLowerCase) ? category2Raw.toLowerCase() : category2Raw,
            images,
            price,
            title,
            slug,
          };
        });
        // eslint-disable-next-line no-console
        console.log('normalized products count:', normalized.length);
        setProductsData(normalized);
      } else {
        setProductsData(array || result);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('fetchData error:', err);
      setProductsData([]);
    }
  }

  const productData = products.allGoogleProductsSheet.edges.map(
    (item) => item.node
  );

  const socialMediaLinks = {
    instagram:
      'https://www.instagram.com/the_antiquities_dealer?igsh=aHpjeGY2cG05aGNz',
    tiktok: 'https://www.tiktok.com/@theantiquitiesdealer?_t=ZN-8x2RwGQ8qzW&_r=1',
    // Add or remove links as needed
  };

  useEffect(() => {
    if (basket.length === 0) {
      setBasketValue(0);
    } else {
      setBasketValue(basket.reduce((acc, item) => acc + item.price, 0));
      setBasketWeight(basket.reduce((acc, item) => acc + item.weight, 0));
    }
  }, [basket]);

  return {
    basketEmptied,
    basket,
    basketValue,
    basketWeight,
    products: productData,
    orderStatus,
    productsData,
    setOrderStatus,
    setBasketEmptied,
    setBasket,
    socialMediaLinks,
    fetchData,
  };
};

const [AppProvider, useAppContext] = constate(useApp);
export { AppProvider, useAppContext };
